export class SearchApiService {
    static async fetchSuggestions(apiUrl, query) {
        const request = new Request(`${apiUrl}?q=${query}`);

        try {
            const response = await fetch(request);
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const json = await response.json();
            return json.results;
        } catch (error) {
            console.error('Error fetching suggestions:', error);
            throw error;
        }
    }

    static async performSearch(config) {
        let requestUrl = `${config.apiUrl}?searchTerm=${config.query}&language=${config.lang}&pageNumber=${config.page}`;

        if (config.activeFilter) {
            requestUrl += `&searchSection=${encodeURIComponent(config.activeFilter)}`;
        }

        const request = new Request(requestUrl);

        try {
            const response = await fetch(request);
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return await response.json();
        } catch (error) {
            console.error('Error performing search:', error);
            throw error;
        }
    }
}